import { useState } from "react";
import { NAV_ITEMS } from "./data";

export default function Sidebar({ activePage, onNavigate, user, onLogout }) {
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);

  const navContent = (
    <>
      {/* Logo */}
      <div style={{ marginBottom: "2rem", padding: "0 0.5rem", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 600, color: "#FFF", letterSpacing: "-0.02em" }}>MealBox</div>
          <div style={{ fontSize: 12, color: "#78716C", marginTop: 2 }}>Business Console</div>
        </div>
        {/* Close button — mobile only */}
        <button onClick={close}
          style={{ display: "none", background: "none", border: "none", color: "#78716C", fontSize: 20, cursor: "pointer", lineHeight: 1 }}
          className="sidebar-close">✕</button>
      </div>

      {/* Nav items */}
      {NAV_ITEMS.map(item => {
        const active = activePage === item.key;
        const isComingSoon = ["orders", "menu"].includes(item.key);
        return (
          <div key={item.key}
            onClick={() => { if (!isComingSoon) { onNavigate(item.key); close(); } }}
            style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10,
              padding: "8px 10px", borderRadius: 8,
              cursor: isComingSoon ? "default" : "pointer",
              background: active ? "#292524" : "transparent",
              color: active ? "#FFF" : isComingSoon ? "#44403C" : "#78716C",
              fontSize: 13, fontWeight: active ? 500 : 400, transition: "all 0.15s" }}>
            <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 14 }}>{item.icon}</span>{item.label}
            </span>
            {isComingSoon && <span style={{ fontSize: 9, background: "#292524", color: "#78716C", padding: "2px 6px", borderRadius: 4 }}>soon</span>}
          </div>
        );
      })}

      {/* User + sign out */}
      <div style={{ marginTop: "auto", padding: "1rem 0.5rem 0", borderTop: "0.5px solid #292524" }}>
        {user && (
          <>
            <div style={{ fontSize: 12, color: "#78716C" }}>Signed in as</div>
            <div style={{ fontSize: 13, color: "#D6D3D1", marginTop: 2, fontWeight: 500 }}>{user.name}</div>
            <div style={{ fontSize: 11, color: "#78716C" }}>{user.city}</div>
          </>
        )}
        <button onClick={onLogout}
          style={{ marginTop: 10, width: "100%", padding: "7px", fontSize: 12, borderRadius: 8,
            border: "0.5px solid #292524", background: "transparent", color: "#78716C", cursor: "pointer" }}>
          Sign out
        </button>
      </div>
    </>
  );

  return (
    <>
      {/* ── Desktop sidebar ── */}
      <aside className="sidebar-desktop" style={{ width: 220, background: "#1C1917", padding: "1.5rem 1rem",
        flexShrink: 0, display: "flex", flexDirection: "column", gap: 4, minHeight: "100vh" }}>
        {navContent}
      </aside>

      {/* ── Mobile top bar ── */}
      <div className="sidebar-topbar" style={{ display: "none", position: "fixed", top: 0, left: 0, right: 0,
        height: 52, background: "#1C1917", zIndex: 200, alignItems: "center",
        justifyContent: "space-between", padding: "0 1rem" }}>
        <div style={{ fontSize: 16, fontWeight: 600, color: "#FFF", letterSpacing: "-0.02em" }}>MealBox</div>
        <button onClick={() => setOpen(true)}
          style={{ background: "none", border: "none", color: "#FFF", fontSize: 22, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center", padding: 4 }}>
          ☰
        </button>
      </div>

      {/* ── Mobile drawer overlay ── */}
      {open && (
        <div onClick={close}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 300 }} />
      )}

      {/* ── Mobile drawer ── */}
      <aside style={{
        position: "fixed", top: 0, left: 0, height: "100vh", width: 240,
        background: "#1C1917", zIndex: 301,
        display: "flex", flexDirection: "column", gap: 4,
        padding: "1.5rem 1rem",
        transform: open ? "translateX(0)" : "translateX(-100%)",
        transition: "transform 0.26s cubic-bezier(.32,.72,0,1)",
        overflowY: "auto",
      }} className="sidebar-mobile">
        {/* Close button row */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.5rem", padding: "0 0.5rem" }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 600, color: "#FFF", letterSpacing: "-0.02em" }}>MealBox</div>
            <div style={{ fontSize: 12, color: "#78716C", marginTop: 2 }}>Business Console</div>
          </div>
          <button onClick={close}
            style={{ background: "none", border: "none", color: "#78716C", fontSize: 20, cursor: "pointer" }}>✕</button>
        </div>

        {NAV_ITEMS.map(item => {
          const active = activePage === item.key;
          const isComingSoon = ["orders", "menu"].includes(item.key);
          return (
            <div key={item.key}
              onClick={() => { if (!isComingSoon) { onNavigate(item.key); close(); } }}
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10,
                padding: "10px 10px", borderRadius: 8,
                cursor: isComingSoon ? "default" : "pointer",
                background: active ? "#292524" : "transparent",
                color: active ? "#FFF" : isComingSoon ? "#44403C" : "#78716C",
                fontSize: 14, fontWeight: active ? 500 : 400 }}>
              <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 15 }}>{item.icon}</span>{item.label}
              </span>
              {isComingSoon && <span style={{ fontSize: 9, background: "#292524", color: "#78716C", padding: "2px 6px", borderRadius: 4 }}>soon</span>}
            </div>
          );
        })}

        <div style={{ marginTop: "auto", padding: "1rem 0.5rem 0", borderTop: "0.5px solid #292524" }}>
          {user && (
            <>
              <div style={{ fontSize: 12, color: "#78716C" }}>Signed in as</div>
              <div style={{ fontSize: 13, color: "#D6D3D1", marginTop: 2, fontWeight: 500 }}>{user.name}</div>
              <div style={{ fontSize: 11, color: "#78716C" }}>{user.city}</div>
            </>
          )}
          <button onClick={onLogout}
            style={{ marginTop: 10, width: "100%", padding: "9px", fontSize: 13, borderRadius: 8,
              border: "0.5px solid #292524", background: "transparent", color: "#78716C", cursor: "pointer" }}>
            Sign out
          </button>
        </div>
      </aside>

      {/* Responsive styles */}
      <style>{`
        @media (max-width: 768px) {
          .sidebar-desktop { display: none !important; }
          .sidebar-topbar  { display: flex !important; }
          .app-main        { padding-top: 52px !important; }
        }
        @media (min-width: 769px) {
          .sidebar-mobile  { display: none !important; }
          .sidebar-topbar  { display: none !important; }
        }
      `}</style>
    </>
  );
}
